window.addEventListener("DOMContentLoaded", () => {
    const dsgnPickSection = document.querySelectorAll(".pick-design-container");
    dsgnPickSection.forEach(section => {
      const openModal = section.querySelector(".dsgn-pck__button-secondary");
      
      const modal = section.querySelector(".popup-modal");
      console.log(section)
      openModal.addEventListener("click", () => {
        modal.classList.add("show-modal");
        const closeModal = section.querySelector(".close-button");
        closeModal.addEventListener("click", () => {
            modal.classList.remove("show-modal");
          });
      });
    });
  });